<div *ngIf="isPro && dias && show_message" class="add-margin alert alert-danger aviso-pro">
    <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
    {{ this.frase }} Renueva tu contrato
    <a href="javascript:void(0)" [routerLink]="['/planes']" class="alert-link">Ahora</a>
    .
</div>
